import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false

// window.axios = require('axios')
// axios.defaults.baseURL = 'http://192.168.54.156:5300';
// Vue.prototype.baseURL = "http://192.168.54.156:5300"
// Vue.prototype.mediaURL = "192.168.54.156:5300/u/"
// Vue.prototype.mediaURLnew = "192.168.54.156:5300/file/get/"

   
axios.defaults.baseURL = 'http://ole.leopardtechlabs.in/';
Vue.prototype.baseURL = "http://ole.leopardtechlabs.in/"
Vue.prototype.mediaURL = "http://ole.leopardtechlabs.in/"
Vue.prototype.mediaURLnew = "http://ole.leopardtechlabs.in/file/get/"

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
